"use client";

import React, { useState, useEffect } from "react";
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date("2026-06-01T23:59:59");
    const updateTimer = () => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      if (difference <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds
      });
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="font-mono text-4xl md:text-6xl lg:text-8xl font-bold tracking-tighter text-primary tabular-nums flex gap-4 md:gap-8 justify-center items-center my-8 md:my-12">
      <div className="flex flex-col items-center">
        <span>{String(timeLeft.days).padStart(2, "0")}</span>
        <span className="text-xs md:text-sm text-primary/60 font-sans tracking-widest mt-2">
          DAYS
        </span>
      </div>
      <span className="text-primary/40 pb-6 md:pb-8">:</span>
      <div className="flex flex-col items-center">
        <span>{String(timeLeft.hours).padStart(2, "0")}</span>
        <span className="text-xs md:text-sm text-primary/60 font-sans tracking-widest mt-2">
          HRS
        </span>
      </div>
      <span className="text-primary/40 pb-6 md:pb-8">:</span>
      <div className="flex flex-col items-center">
        <span>{String(timeLeft.minutes).padStart(2, "0")}</span>
        <span className="text-xs md:text-sm text-primary/60 font-sans tracking-widest mt-2">
          MIN
        </span>
      </div>
      <span className="text-primary/40 pb-6 md:pb-8 hidden md:inline">:</span>
      <div className="flex flex-col items-center hidden md:flex">
        <span>{String(timeLeft.seconds).padStart(2, "0")}</span>
        <span className="text-xs md:text-sm text-primary/60 font-sans tracking-widest mt-2">
          SEC
        </span>
      </div>
    </div>;
}
export default function TheAbyssPreOrder() {
  return <section id="march-31st-launch-countdown" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 radiating-pattern">
      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="h2 text-foreground mb-4">FOUNDING MEMBER ACCESS CLOSES JUNE 1st</h2>
          <p className="text-primary font-mono text-sm md:text-base tracking-widest uppercase">
            The system that sends an instant WhatsApp to your missed calls.
          </p>
        </div>

        <CountdownTimer />

        <div className="mt-16 relative">
          <div className="absolute -top-8 left-0 w-8 h-8 border-t-2 border-l-2 border-primary/40 hidden md:block" />
          <div className="absolute -top-8 right-0 w-8 h-8 border-t-2 border-r-2 border-primary/40 hidden md:block" />
          <div className="absolute -bottom-8 left-0 w-8 h-8 border-b-2 border-l-2 border-primary/40 hidden md:block" />
          <div className="absolute -bottom-8 right-0 w-8 h-8 border-b-2 border-r-2 border-primary/40 hidden md:block" />

          <div className="w-full max-w-2xl mx-auto glass-panel metallic-border overflow-hidden" style={{
          color: '#1a1a1a'
        }}>
            <style>{`
              #inline-cofUX3tcpj556BJPhSE0 input, 
              #inline-cofUX3tcpj556BJPhSE0 select, 
              #inline-cofUX3tcpj556BJPhSE0 textarea {
                color: #1a1a1a !important;
                background-color: #ffffff !important;
              }
            `}</style>
            <iframe src="https://connect.thinklocalpro.com/widget/form/cofUX3tcpj556BJPhSE0" style={{
            width: "100%",
            height: "800px",
            border: "none"
          }} id="inline-cofUX3tcpj556BJPhSE0" title="Secure Founder Spot" sandbox="allow-scripts allow-same-origin allow-forms allow-popups"></iframe>
            <script src="https://connect.thinklocalpro.com/js/form_embed.js" async></script>
          </div>
        </div>
      </div>
    </section>;
}